module.exports = __webpack_public_path__ + "pin.svg?77a1926a1daf21c08c1bf66e30db42fe";